<template>
  <section class="clh">
    <img
      :src="require('@/assets/clearmentai/plus.png')"
      alt="Clearment Plus"
      class="clh__logo"
    />
    <div class="clh__main">
      <div class="clh__eyebrow">Clearment</div>
      <h2 class="clh__title">Vertragsschutz</h2>
      <p class="clh__text">
        Der Clearment Vertragsschutz ist die Versicherung für Ihre Versicherung.
        Bei Abschluss <strong>kostenlos</strong> während der gesamten
        Vertragslaufzeit.
        <a
          class="clh__link"
          @click="berechnungStore.setShowPop(false, 'vertragsschutz')"
        >
          Lesen Sie mehr dazu →
        </a>
      </p>
    </div>
  </section>
</template>

<script setup>
  import { useBerechnungStore } from "@/stores/berechnung";
  const berechnungStore = useBerechnungStore();
</script>

<style scoped>
  .clh {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 18px;
    align-items: start;
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-left: 3px solid #0f4c81;
    border-radius: 3px;
    padding: 12px 16px;
  }
  .clh__logo {
    width: 48px;
    height: auto;
    flex-shrink: 0;
    display: block;
    margin-top: 2px;
  }
  .clh__main {
    min-width: 0;
  }
  .clh__eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    color: #5b6473;
    text-transform: uppercase;
    margin-bottom: 2px;
  }
  .clh__title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.2;
    letter-spacing: -0.2px;
  }
  .clh__text {
    margin: 6px 0 0;
    font-size: 13px;
    color: #4b5563;
    line-height: 1.5;
  }
  .clh__text strong {
    color: #0f172a;
  }
  .clh__link {
    color: #0f4c81;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    margin-left: 4px;
    white-space: nowrap;
  }
  .clh__link:hover {
    text-decoration: underline;
  }

  @media (max-width: 600px) {
    .clh {
      gap: 12px;
      padding: 10px 12px;
    }
    .clh__logo {
      width: 40px;
    }
  }
</style>
